const importSignupsAll = () =>
  import("Signups/SignupView/SignupsListAndArchivePage");

export { importSignupsAll };
